import { render, staticRenderFns } from "./PageParams.vue?vue&type=template&id=e754c52a"
import script from "./PageParams.vue?vue&type=script&lang=js"
export * from "./PageParams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports